<template>
  <div>
<!--    <div-->
<!--      class="w-full text-white tracking-wider bg-gradient-to-r from-gray-700 to-blue-500 rounded-b-md mb-4"-->
<!--    >-->
<!--      <div-->
<!--        class=" py-6 px-8 lg:px-0 max-w-4xl m-auto font-roboto px-6 lg:px-0"-->
<!--      >-->
<!--        <div class="flex justify-between">-->
<!--          <a href="/" class="self-center">-->
<!--            <img src="@/assets/images/logo.png" width="150" alt="Phantom" />-->
<!--          </a>-->
<!--          <div class="w-2/3 md:w-1/2 text-right">-->
<!--            <span class="font-medium text-xl">Contact us:</span>-->
<!--            <ul class="mt-2 text-sm sm:text-base">-->
<!--              <li class="py-1">sales@phantom-technologies.com</li>-->
<!--              <li class="py-1">+972-3-9215720</li>-->
<!--              <li class="py-1">phantom-technologies.com</li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="w-full max-w-4xl m-auto font-roboto my-6 px-6 lg:px-0">
      <Main v-if="page === 'main'" />
      <Order v-if="page === 'order'" />
      <success v-if="page === 'success'" />
<!--      <order-popup v-if="page === 'order-popup'" />-->
    </div>
  </div>
<!--  <div-->
<!--    class="w-full text-white tracking-wider bg-gradient-to-r from-gray-700 to-blue-500 rounded-t-md"-->
<!--  >-->
<!--    <div-->
<!--      class=" py-12 mt-8 px-6 lg:px-0 max-w-4xl m-auto font-roboto px-6 lg:px-0"-->
<!--    >-->
<!--      <div class="flex justify-between">-->
<!--        <div class="w-2/3 md:w-1/2">-->
<!--          <span class="font-medium text-xl">Contact us:</span>-->
<!--          <ul class="mt-2 text-sm sm:text-base">-->
<!--            <li class="py-1">sales@phantom-technologies.com</li>-->
<!--            <li class="py-1">+972-3-9215720</li>-->
<!--            <li class="py-1">phantom-technologies.com</li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <a href="/" class="self-start">-->
<!--          <img src="@/assets/images/logo.png" width="150" alt="Phantom" />-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <order-popup v-if="page === 'order-popup'" />
</template>

<script>
import Order from "./components/order";
import Main from "./components/main";
import OrderPopup from "@/components/OrderPopup";
import success from "@/components/success";

export default {
  name: "App",
  components: {
    Order,
    Main,
    OrderPopup,
    success,
  },
  data() {
    return {
      page: "order-popup",
    };
  },
};
</script>

<style lang="scss"></style>
